import React from 'react';
import { motion } from 'framer-motion';
export function StatsBanner() {
  const stats = [{
    value: '2',
    label: 'Guías digitales disponibles'
  }, {
    value: '+500',
    label: 'Personas transformadas'
  }, {
    value: '7-21',
    label: 'Días al primer resultado'
  }, {
    value: '100%',
    label: 'Natural y sin medicamentos'
  }];
  return <section className="bg-brand-cream py-16 border-y border-brand-emerald/10" data-id="element-193">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-194">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center divide-x-0 md:divide-x divide-brand-emerald/20" data-id="element-195">
          {stats.map((stat, index) => <motion.div key={index} className="flex flex-col items-center justify-center px-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-196">
              <span className="font-display text-4xl lg:text-5xl font-bold text-brand-emerald mb-2" data-id="element-197">
                {stat.value}
              </span>
              <span className="text-sm lg:text-base font-medium text-brand-charcoal/80 max-w-[150px]" data-id="element-198">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}